import { PLUGIN_ID } from './pluginId'

export const ACTION_RESOLVE_CONFIG = `${PLUGIN_ID}/resolve-config`
